import { render, staticRenderFns } from "./edit-supplier.vue?vue&type=template&id=28d87088&"
import script from "./edit-supplier.vue?vue&type=script&lang=js&"
export * from "./edit-supplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports